import { render, staticRenderFns } from "./KonvaRichNotes.vue?vue&type=template&id=ac27f110"
import script from "./KonvaRichNotes.vue?vue&type=script&lang=js"
export * from "./KonvaRichNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports